class IffalconCollectionFilters extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#applyFilters);
    this.querySelector('[data-iffalcon-clear-filters]')?.addEventListener('click', this.#clearFilters);
    this.querySelector('[data-iffalcon-filter-toggle]')?.addEventListener('click', this.#toggleFilters);
    this.#applyFilters();
  }

  #toggleFilters = () => {
    const toggle = this.querySelector('[data-iffalcon-filter-toggle]');
    if (!(toggle instanceof HTMLButtonElement)) return;

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    this.toggleAttribute('data-mobile-open', !isOpen);
  };

  #selectedValues(group) {
    return Array.from(this.querySelectorAll(`input[data-filter-group="${group}"]:checked`), (input) =>
      input.value.toLowerCase()
    );
  }

  #applyFilters = () => {
    const collection = this.closest('.iffalcon-collection');
    if (!collection) return;

    const selectedFeatures = this.#selectedValues('feature');
    const selectedSizes = this.#selectedValues('size');
    let visibleCount = 0;

    for (const item of collection.querySelectorAll('.product-grid__item')) {
      const features = (item.dataset.collectionFeatures || '').toLowerCase().split('|').filter(Boolean);
      const sizes = (item.dataset.collectionSizes || '').toLowerCase().split('|').filter(Boolean);
      const matchesFeatures = selectedFeatures.length === 0 || selectedFeatures.some((value) => features.includes(value));
      const matchesSizes = selectedSizes.length === 0 || selectedSizes.some((value) => sizes.includes(value));
      const isVisible = matchesFeatures && matchesSizes;

      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    }

    this.toggleAttribute('data-has-active-filters', selectedFeatures.length + selectedSizes.length > 0);
    const mobileCount = this.querySelector('[data-iffalcon-result-count]');
    if (mobileCount) mobileCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'Result' : 'Results'}`;
    for (const count of collection.querySelectorAll('.products-count-wrapper [role="status"]')) {
      count.textContent = `${visibleCount} ${visibleCount === 1 ? 'item' : 'items'}`;
    }
  };

  #clearFilters = () => {
    for (const input of this.querySelectorAll('input[type="checkbox"]')) input.checked = false;
    this.#applyFilters();
  };
}

if (!customElements.get('iffalcon-collection-filters')) {
  customElements.define('iffalcon-collection-filters', IffalconCollectionFilters);
}
